// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2w7mI","title":"BackImages_title__tzvA6","images":"BackImages_images__2VhPJ"};